    import VueAvatar from '@/components/vue-avatar-editor/VueAvatar.vue'
    import VueAvatarScale from '@/components/vue-avatar-editor/VueAvatarScale.vue'
    import { mapGetters } from 'vuex';
    import axios from 'axios';
    export default 
    {
        props: ['product_id', 'multi_book_id', 'show_upload_picture','title'],
        name: "product_image_crop_model",
        components: 
        {
            VueAvatar,
            VueAvatarScale
        },   
        data: function () 
        {
            return {
                images_list: [],
                imageBlock: 'col-12',
                editImageBlock: '',
                hideOrShowEditImageBlock: true,
                hideOrShowEditButton: false,
                imgToCrop: '',
                image_public_id: 0,
                thumbnail_public_id: 0,
                product_image_id: 0,
                warning_file: false,
                upload_file: false,
                upload_success: false,
                selected_image_index:0,
                upload_fail: false,
                isDragging: false,
                show_upload_pictures_screen:false,
                dragCount: 0,
                test_image:'',
                status_processing: 'Uploading...',
                status_success: 'Successfully Uploaded.',
                status_failed: 'Failed to Uploaded.',
                warning_file_message: 'Only JPG, JPEG and PNG image formats with max 5MB size are accepted.'
            }
        },
        mounted () 
        {
            this.show_upload_pictures_screen = this.show_upload_picture;
        },
        computed: {
            ...mapGetters(["get_product_images", "upload_product_image"]),
            product_images(){
                return this.$store.state.product_image_url_data;
            }
        },
        watch: {
            warning_file: function (status) {
                if(status == true) setTimeout(() => this.warning_file = false, 3000);
            },
            upload_success: function (status) {
                if(status == true) setTimeout(() => this.upload_success = false, 3000);
            },
            upload_fail: function (status) {
                if(status == true) setTimeout(() => this.upload_fail = false, 3000);
            },
            upload_file: function (status) 
            {
                var buttonsToDisable = document.getElementsByClassName('disableOnProcess');
                if(status == true) 
                    buttonsToDisable.forEach(btnElem => { btnElem.disabled = true });
                else if(status == false) 
                    buttonsToDisable.forEach(btnElem => { btnElem.disabled = false });
            },
        },
        methods: {
            async get_product_details() 
            {
                this.$store.state.product_image_url_data = [];
                axios.post(this.$store.state.api +'v2/products/get_product_details_v2',{
                    "product_id" :this.product_id
                }).then(response => {
                   if(response.data.result.product_images.length > 0){
                        var image_obj = {};
                        var index = 0;
                        response.data.result.product_images.forEach(product_images => {
                            image_obj = {
                                index:index,
                                is_default:product_images.is_default,
                                product_image_id:product_images.product_image_id,
                                image:product_images.product_image_url,
                                image_public_id:product_images.product_image_public_id,
                                thumbnail_public_id:product_images.product_thumbnail_public_id,
                                show_is_default_button:false

                            }
                            this.$store.state.product_image_url_data.push(image_obj);
                            index++;
                        });
                    }
                })
            },
            onChangeScale (scale) 
            {
                this.$refs.vueavatar.changeScale(scale)
            },
            uploadImageButton(upload) 
            {
                // this.show_status(false, false, false, false)
                var target_img = upload.target.files[0];
                this.upload_new_image(target_img);
            },
            upload_new_image(target_img)
            {
                if(typeof target_img === 'undefined') return;
                const acceptedImageTypes = ['image/jpg', 'image/jpeg', 'image/png'];
                if(!acceptedImageTypes.includes(target_img['type']))
                {
                    this.warning_file_message = 'Only JPG, JPEG and PNG image formats are accepted.';
                    // this.show_status(true, false, false, false)
                    return;
                }
                this.status_processing = 'Uploading Image...';
                this.upload_file = true;
                var target_img_size = Math.round(( target_img.size / 1024));
                this.test_image = URL.createObjectURL(target_img);
                if(target_img != null && target_img_size <= 5120)
                {
                    this.imgToBase64(target_img).then(base64_img => {
                        let upload_img = [{"index":this.$store.state.product_image_url_data.length,"image":base64_img}]
                        if(this.title == 'New Product') 
                        {
                            this.$store.state.product_image_url_data.push({index:this.$store.state.product_image_url_data.length,image:upload_img[0].image,show_is_default_button:false});
                            this.show_upload_pictures_screen = true;
                            this.upload_file = false;
                        }
                        else this.sendImageToApi(upload_img, this.Constants.UPLOAED_IMAGE_FLAG)
                    });
                }
                else if(target_img_size > 5120) 
                {
                    this.warning_file = true;
                    this.upload_file = false;
                    this.warning_file_message = 'Image size exceeds maximum limit 5MB.';
                }
            },
            imgToBase64(file) {
                return new Promise(resolve => {
                    var reader = new FileReader();
                    reader.onload = function(event) { resolve(event.target.result); }
                    reader.readAsDataURL(file);
                });
            },
            cropImage()
            {
                this.upload_file = true;
                this.status_processing = 'Cropping Image...'
                var crop = this.$refs.vueavatar.getImage()
                if(crop != false)
                {
                    let cropped_img = [{
                                        "image":this.$refs.vueavatar.getImage().toDataURL(),
                                        "image_public_id":this.image_public_id,
                                        "thumbnail_public_id":this.thumbnail_public_id,
                                        "product_image_id":this.product_image_id
                                    }]
                    this.sendImageToApi(cropped_img, this.Constants.CROP_IMAGE_FLAG)
                }
            }, 
            async sendImageToApi(img_obj, upload_type_flag) 
            {
                if(this.title != 'New Product'){
                    await  this.$store.dispatch('upload_product_image',[
                                this.$store.state.api,
                                this.$session.get('store_id'),
                                this.product_id,
                                img_obj,
                                this.$store.state.user_id, 
                                upload_type_flag
                    ]);
                    this.upload_file = false;
                    this.show_upload_pictures_screen = true;
                    this.get_product_details();
                    this.cancelImageButton();
                    if(upload_type_flag == this.Constants.CROP_IMAGE_FLAG) {
                        this.upload_success = true;
                        this.status_success = 'Image Cropped Successfully.'
                    }
                    else {
                        this.upload_success = true;
                        this.status_success = 'Successfully Uploaded.'
                    }
                }

                else {
                    this.$store.state.product_image_url_data.push(img_obj[0]);
                    if(upload_type_flag == this.Constants.CROP_IMAGE_FLAG) {
                        this.$store.state.product_image_url_data.splice(this.selected_image_index,1);
                        this.upload_file = false;
                        this.upload_success = true;
                        this.status_success = 'Image Cropped Successfully.'
                    }
                    this.cancelImageButton();
                }
                this.images_list = this.$store.state.product_image_url_data;
                this.show_upload_pictures_screen = true;
            },   
            onImageReady(scale)
            {
                this.$refs.vueavatarscale.setScale(scale)
            },
            editImage(imageSource) 
            {
                if(this.title == 'New Product') this.selected_image_index = imageSource.index
                if (this.hideOrShowEditImageBlock == false)
                {
                    this.imgToCrop                  = imageSource.image;
                    this.image_public_id            = imageSource.image_public_id;
                    this.thumbnail_public_id        = imageSource.thumbnail_public_id;
                    this.product_image_id           = imageSource.product_image_id;
                }              
            },
            auto_select_first_image() {
                if(this.$store.state.product_image_url_data.length > 0)
                {
                    this.editImage(this.$store.state.product_image_url_data[0])
                }
            },
            editImageButton() 
            {
                this.modelBlockDivision('col-6', 'col-6', false, true)
                this.auto_select_first_image();
            },
            cancelImageButton() 
            {
                this.modelBlockDivision('col-12', '', true, false);
            },
            modelBlockDivision(imageBlock, editImageBlock, hideOrShowEditImageBlock, hideOrShowEditButton) 
            {
                this.imageBlock                 = imageBlock;
                this.editImageBlock             = editImageBlock;
                this.hideOrShowEditImageBlock   = hideOrShowEditImageBlock;
                this.hideOrShowEditButton       = hideOrShowEditButton;
                this.imgToCrop                  = '';
            },
            
            OnDragEnter(img_obj) {
                img_obj.preventDefault();            
                this.dragCount++;
                this.isDragging = true;
                return false;
            },
            OnDragLeave(img_obj) {
                img_obj.preventDefault();
                this.dragCount--;
                if (this.dragCount <= 0)
                    this.isDragging = false;
            },
            onDrop(img_obj) {
                img_obj.preventDefault();
                img_obj.stopPropagation();
                this.isDragging = false;
                const files = img_obj.dataTransfer.files[0];
                this.upload_new_image(files)
                // Array.from(files).forEach(file => this.upload_new_image(file));
            },
            deleteImage( index,image_public_id, thumbnail_public_id, product_image_id) 
            {
                this.upload_file = true;
                this.status_processing = 'Deleting Image...';
                if(this.title == 'New Product'){
                    this.$store.state.product_image_url_data.splice(index,1);
                }
                else{
                    axios.post(this.$store.state.api +'v2/products/delete_product_images_v2',{
                        "product_id" :this.product_id,
                        "image_details" : [
                            {
                            "product_image_id":product_image_id,
                            "image_public_id": image_public_id,
                            "thumbnail_public_id": thumbnail_public_id
                            }],
                        "updated_by":this.$store.state.user_id
                    }).then(response =>{
                       if(response.data.status == 200){
                            this.upload_file = false;
                            this.status_processing = '';
                            this.upload_success = true;
                            this.status_success = 'Image Deleted Successfully.'
                            if(this.$store.state.product_image_url_data[index].is_default){
                                this.$store.state.product_image_url_data.splice(index,1);
                                this.make_default();
                            }
                           this.get_product_details();
                           
                       }
                    })
                }
            },
            make_default(){
                axios.post(this.$store.state.api +'v2/products/make_image_default_v2',{
                    "product_id":this.$session.get('selected_product_id'),
                    "product_image_id" : this.$store.state.product_image_url_data[0].product_image_id,
                    "updated_by" : this.$store.state.user_id
                }).then(response =>{
                    if(response.data.status == 200){
                        this.$store.state.product_image_url_data.forEach(product => {
                            if(product.is_default == 1)product.is_default = 0
                            product.show_is_default_button=false
                        });
                        this.$store.state.product_image_url_data[this.default_image_call_details.index].is_default = 1;
                    }
                })
            },
            // statusUpdate(status_processing, status_success, status_failed)
            // {
            //     this.status_processing  = status_processing;
            //     this.status_success     = status_success;
            //     this.status_failed      = status_failed;
            // }
        }
    }